import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebase-auth';
import { onAuthStateChanged, signOut } from 'firebase/auth';

import Sidebar from './Sidebar';

const Header = ({ user }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [profilePic, setProfilePic] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [username, setUsername] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const hideAppBar = (user === null && location.pathname === '/') || location.pathname === '/signin' || location.pathname === '/terms-and-privacy';

  useEffect(() => {
    if (user !== null) {
      setIsLoggedIn(true);
      setProfilePic(user.photoURL == null ? "https://fastly.picsum.photos/id/168/200/200.jpg?hmac=VxnpUGg87Q47YRONmdsU2vNGSPjCs5vrwiAL-0hEIHM" : user.photoURL);
      setUsername(user.displayName == null ? "User" : user.displayName);
    } else {
      setIsLoggedIn(false);
    }
  }, [user]);

  const handleBlogClick = () => {
    navigate("/blog");
  };

  const handleDatasetClick = () => {
    navigate("/cdatasets");
  };

  const handleCreditClick = () => {
    navigate("/creditinfo");
  };

  const handleDataHistoryClick = () => {
    navigate("/datahistory");
  }

  const handleMarketplaceClick = () => {
    navigate("/marketplace");
  }

  const handleLogout = async () => {
    try {
      await signOut(auth);
      user = null;
      setShowDropdown(false);
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };

  // const navigation = [
  //   { name: 'Home', href: '/' },
  //   { name: 'Features', href: '/features' },
  //   { name: 'Pricing', href: '/pricing' },
  //   { name: 'Data Marketplace', href: '/marketplace' },
  //   { name: 'Community', href: '/community' },
  //   { name: 'Blog', href: '/blog' },
  // ];

  return (
    <>
      {!hideAppBar && (
        <>
          <header className="flex items-center px-4 h-[52px] bg-white border-b border-gray-200 sticky top-0 z-40">
            <button
              onClick={() => setShowDropdown(v => !v)}
              className="inline-flex flex-col justify-center items-center gap-[3px] w-8 h-8 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 mr-3"
              title="Toggle menu"
            >
              <span className="block w-4 h-[2px] bg-gray-700"></span>
              <span className="block w-4 h-[2px] bg-gray-700"></span>
              <span className="block w-4 h-[2px] bg-gray-700"></span>
            </button>

            <Link to="/" className="text-xl font-bold text-blue-700 hover:text-blue-900 transition-colors duration-300 tracking-tight">
              DataCreator AI<sup className="text-xs font-semibold text-blue-600 ml-0.5">Beta</sup>
            </Link>

            <nav className="hidden md:flex items-center ml-8 gap-6">
              <Link to="/clean" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Workspace</Link>
              <Link to="/datahistory" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Data History</Link>
            </nav>

            <div className="flex-1"></div>

            {!user && (
              <button
                onClick={() => navigate('/signin')}
                className="bg-blue-600 text-white px-4 py-1.5 text-sm font-medium rounded-md hover:bg-blue-700 transition duration-300 shadow-sm"
              >
                Sign Up
              </button>
            )}
          </header>


        {/* Left sidebar */}
        <Sidebar
          isLoggedIn={isLoggedIn}
          username={username}
          profilePic={profilePic}
          onLogout={handleLogout}
          open={showDropdown}
          onClose={() => setShowDropdown(false)}
        />

        {/* Shift page content when sidebar open */}
        <style>{`
          body { transition: padding-left 200ms ease; }
          @media (min-width: 768px) {
            ${showDropdown ? 'body { padding-left: 14rem; }' : 'body { padding-left: 0; }'}
          }
        `}</style>
      </>
    )}
  </>
);
};

export default Header;